import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-215bed0c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  ref: "left_all",
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = {
  style: {
    "width": "314px",
    "margin": "25px 22px"
  },
  ref: "left_selector"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

const _hoisted_4 = {
  class: "el-submenu__title",
  style: {
    "width": "360px"
  }
};
const _hoisted_5 = ["title"];
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ticket = _resolveComponent("Ticket");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_tree = _resolveComponent("el-tree");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Ticket, {
    show: $data.ticket.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.ticket.show = $event),
    questionType: $data.ticket.questionType
  }, null, 8, ["show", "questionType"]), _createVNode(_component_el_tooltip, {
    effect: "light",
    content: $options.ticketTooltipContent
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "ticket",
      style: _normalizeStyle($options.ticketStyle),
      onClick: _cache[1] || (_cache[1] = $event => $options.clickToAfterSales()),
      ref: "left_ticket"
    }, _toDisplayString(_ctx._t("afterSalesQuestion")) + "(" + _toDisplayString($data.unreadCount_new) + "/" + _toDisplayString($data.unrresolvedCount_new) + ")", 5)]),
    _: 1
  }, 8, ["content"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
    style: {
      "width": "100%"
    },
    modelValue: $data.itemFilterSelected,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.itemFilterSelected = $event),
    placeholder: _ctx._t('productFilter'),
    "value-key": "id",
    onVisibleChange: $options.visibleChangeItemFilter,
    multiple: "",
    onRemoveTag: _cache[3] || (_cache[3] = $event => $options.visibleChangeItemFilter(false))
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValidItem, _item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: _item.id,
        value: _item.id,
        label: _item.name
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_item.name) + _toDisplayString(_item.description ? '(' + _item.description + ')' : ''), 1)]),
        _: 2
      }, 1032, ["value", "label"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "placeholder", "onVisibleChange"])], 512), _hoisted_3, _createVNode(_component_el_row, {
    class: "tac"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12
    }, {
      default: _withCtx(() => [_createElementVNode("h5", {
        ref: "left_title"
      }, _toDisplayString($options.catalogTitle), 513), _createVNode(_component_el_tree, {
        ref: "left_tree",
        class: "tree1",
        data: $options.catalogContent,
        props: $data.catalogProps,
        "default-expanded-keys": [_ctx.questionId],
        "default-active": "2",
        "node-key": "id",
        "highlight-current": "",
        onNodeClick: $options.clickElement,
        "background-color": "#ffffff",
        "text-color": "#1c1d1f",
        "active-text-color": "#1c1d1f",
        style: _normalizeStyle({
          height: $data.tree_height
        })
      }, {
        default: _withCtx(({
          node,
          data
        }) => [_createElementVNode("span", _hoisted_4, [!data.isQuestion ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(node.expanded ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline'),
          style: {
            "font-size": "18px",
            "width": "24px",
            "text-align": "center"
          }
        }, null, 2)) : _createCommentVNode("", true), _createElementVNode("span", {
          title: node.label
        }, _toDisplayString(node.label), 9, _hoisted_5), !data.isQuestion ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: "tree-node-ticket el-icon-chat-dot-round",
          onClick: _withModifiers($event => $options.clickTicket($event, data), ["stop"])
        }, null, 8, _hoisted_6)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["data", "props", "default-expanded-keys", "onNodeClick", "style"])]),
      _: 1
    })]),
    _: 1
  })], 512);
}